import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalPizzaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_pizza"}/>
}
